var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";
const Button = (props) => {
    const { style = {}, className = "", text = "", children, size = "medium", bold = true } = props, restProps = __rest(props, ["style", "className", "text", "children", "size", "bold"]);
    const isSmall = size === "small";
    const sizeConfig = {
        xs: "px-5 py-1 text-xs",
        small: "inline-block px-4 py-2",
        medium: "px-5 py-2.5",
        large: "h-12 px-5 py-2.5",
        default: "px-5 py-2.5",
    };
    const cls = twMerge(`uppercase text-sm ${bold ? "buttonFontWeight" : ""} select-none appearance-none border disabled:cursor-not-allowed rounded-md ${sizeConfig[size] || sizeConfig.default} `, className);
    return (_jsx("button", Object.assign({ style: Object.assign({ minWidth: isSmall ? undefined : "9rem", transition: "box-shadow 0.3s ease-in-out" }, style), className: cls, onMouseOver: (e) => {
            e.currentTarget.style.boxShadow = "0 4px 6px -1px #CACACA";
        }, onMouseLeave: (e) => {
            e.currentTarget.style.boxShadow = "none";
        } }, restProps, { children: children || t(text) })));
};
const ButtonPropTypes = {
    disabled: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseLeave: PropTypes.func,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    children: PropTypes.node,
};
Button.propTypes = ButtonPropTypes;
export { Button, ButtonPropTypes };
